export const checkValidation = (channel) => {
  const { validated, validate_state } = channel;

  if (!!validated || validate_state === "valid") return [true, validate_state];
  return [false, validate_state || null];
};
